"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  ins: {
    paymentNo01: '申请单号',
    handleUserName: '当前处理人',
    invoiceNo02: '关联发票号',
    quitType01: '退费类型',
    quit: '退保',
    quitBack: '取消退保',
    insDay: '保险天数',
    insDetail: '保险明细',
    insType: '保费类型',
    lockOrder: '锁单',
    unLockOrder: '解锁',
    insureType: '保险类型',
    invoiceType: '发票类型',
    invoiceDate: '发票时间',
    invoiceDate01: '保险区间',
    payStatus: '付款状态',
    creator: '经办人',
    feeType: '费用类型',
    insCompanyName: '保险公司/协会',
    insCompany: '保险公司',
    insCompany01: '保险商',
    dueDate: '到期时间',
    payDate: '实付时间',
    underwriteDates: '承保区间',
    invoiceNo: '发票号',
    invoiceNo01: '单据号',
    particular: '付款事由',
    amount: '发票金额',
    sumStagesNum: '分期数',
    sumStagesNum02: '期数',
    currencyTo: '转换币种',
    quitType: '会费发票状态',
    approvalStatus: '审批状态',
    shareStatus: '付款状态',
    shareStatus01: '结算标志',
    settleDate: '实付日期',
    insYear: '保险年度',
    paymentNo: '付款单号',
    createTime: '经办时间',
    settleOfficeName: '收款人',
    voyageNoInsuranceInvoice: '航次保险发票登记',
    voyageNoInsuranceInvoice2: '航次保险发票',
    oCurrency: '原币种',
    bCurrency: '本币种',
    cCurrency: '转换币种',
    changeRate: '间接汇率',
    invoiceAmount: '原币金额',
    baseInvoiceAmount: '转换金额',
    remark: '备注',
    voyageDetail: '船舶明细',
    invoiceManage: '供应商税票管理',
    undertakeCompanyName: '承担公司',
    payCurrency: '支付币种',
    originAmount: '原金额',
    finType: '承保类型',
    notNull: '不能为空',
    insItem: '保险项目',
    insInitiator: '保险牵头人',
    vesselName: '保险船舶',
    sumInsured: '保额',
    sumNetPremiumRmb: '保额(人民币)',
    quitDate: '退保日期',
    days: '年度天数',
    feeAmount: '免赔额',
    insAgreement: '保险协议号',
    insAgreement01: '保险协议单号',
    insCompanyNameEn: '保险人',
    insCompanyNameEn01: '保险人1',
    insCompanyNameEn02: '保险人2',
    insAmount: '100%保费',
    insScale: '承担比例',
    insDisRate: '折扣比例',
    insDisAmount: '折后保费',
    brokerRate: '佣金率',
    brokerComm: '佣金',
    netPremium: '净保费',
    netPremiumRmb: '净保费(人民币)',
    preNetPremium: '追加净保费',
    currencyCode: '币种',
    baseCurrencyCode: '币种',
    tax: '税率',
    vesselGwt: '船舶总吨',
    advanceCallAmount: '预付会费',
    advanceCallRate: '预付会费率',
    supplementaryRate: '会费追加比例',
    supplementaryAmount: '追加会费',
    supplementaryPreAmount: '追加保费',
    supplementaryAmountRate: '追加会费比例',
    adjustmentRate: '再保费率',
    adjustmentAmount: '再保费',
    estTotalCall: '预计总会费',
    insCompanyCode: '公司',
    deductibleAndRemark: '免赔及备注',
    feeDetail: '费用明细',
    beginTime: '开始时间',
    endTime: '结束时间',
    sumFddGrossPremium: '会费',
    sumAfterB2bPremium: '折扣金额',
    sumBrokerComm: '佣金',
    preBrokerComm: '追加佣金',
    sumEstTotalCall: '总金额',
    fddMinDay: 'FDD最小天数',
    delDate: '交船日',
    redDate: '还船日',
    totalDay: '天数',
    piGrossPremium: 'P&I Gross Premium会费',
    b2bDiscount: 'B2B折扣',
    afterB2bPremium: 'After B2B P&I Gross Premium会费',
    fddGrossPremium: 'FD&D Gross Premium会费',
    ownerPni: '船东保赔协会',
    template: '模板',
    sumNetPremium: '保费',
    allNetPremium: '总保费',
    amount01: '金额',
    insStart: '生效日期',
    insEnd: '终止日期',
    addComInvoice: '生成航次保险发票',
    conventionFeeInvoice: '常规保费发票',
    insuranceRefundInvoice: '保险退费发票',
    sumStagesDetail: '分期明细',
    paySplit: '分期',
    clubYear: '返还年度',
    taxRate: '税率',
    taxAmount: '税额',
    refundAmount: '退费金额',
    refundRate: '退费比率',
    quitTime: '退会日期',
    collectionApplication: '收款申请',
    paymentApplication: '付款申请',
    baseAmount: '本币金额',
    baseCurrency: '本位币种',
    illustrate: '事由说明',
    totalProject: '总计项目',
    insAgreemntAmount: '协议金额',
    insClaim: {
      ispFleetCode: '船队',
      vesselName: '船舶',
      voyageNo: '航次',
      caseCategory: '案件类型',
      caseNo: '内部案件号',
      insComCaseNo: '保险公司案件号',
      dateOfIncident: '事故发生时间',
      endCaseFlag: '是否结案',
      location: '事故发生地点',
      caseName: '案件名称'
    }
  }
};